import { axiosInstance, axiosInstanceForm } from "../../Utils/AxiosInstance";

/**
 * Purchase Invoices API Service
 */
export const GetAllPurchaseInvoicesApi = async (projectId) => {
  try {
    const query = projectId ? `?projectId=${projectId}` : "";
    const response = await axiosInstance.get(`/PurchaseInvoices/GetAll${query}`);
    return { ...response };
  } catch (error) {
    return { ...error?.response };
  }
};

export const AddPurchaseInvoiceApi = async (data) => {
  try {
    const response = await axiosInstanceForm.post(`/PurchaseInvoices/Create`, data);
    return { ...response };
  } catch (error) {
    return { ...error?.response };
  }
};

export const UpdatePurchaseInvoiceApi = async (data, id) => {
  try {
    const response = await axiosInstanceForm.put(`/PurchaseInvoices/Edit/${id}`, data);
    return { ...response };
  } catch (error) {
    return { ...error?.response };
  }
};

export const GetPurchaseInvoiceByIdApi = async (id) => {
  try {
    const response = await axiosInstance.get(`/PurchaseInvoices/GetById/${id}`);
    return { ...response };
  } catch (error) {
    return { ...error?.response };
  }
};

export const DeletePurchaseInvoiceApi = async (id) => {
  try {
    const response = await axiosInstance.delete(`/PurchaseInvoices/Delete/${id}`);
    return { ...response };
  } catch (error) {
    return { ...error?.response };
  }
};

export const GetBillablePurchaseInvoiceApi = async (poId) => {
  try {
    const response = await axiosInstance.get(`/PurchaseInvoices/GetBillable/${poId}`);
    return { ...response };
  } catch (error) {
    return { ...error?.response };
  }
};

export const PostPurchaseInvoiceApi = async (id) => {
  try {
    const response = await axiosInstance.put(`/PurchaseInvoices/Post/${id}`);
    return { ...response };
  } catch (error) {
    return { ...error?.response };
  }
};

export const CancelPurchaseInvoiceApi = async (id, reason) => {
  try {
    const response = await axiosInstance.put(`/PurchaseInvoices/Cancel/${id}`, null, {
      params: { reason },
    });
    return { ...response };
  } catch (error) {
    return { ...error?.response };
  }
};
